import { OneSearchVehicleTileDataParams } from '../../http/clients/onesearch/graphql/OneSearchGraphQL';
import { SharedRequestConfiguration } from '../../types/GeneralParameter';
import { vehicleCategoryCommercial, vehicleCategoryPrivate } from '../VansCompatMap';
import { createVanConfiguration } from '../VansConfiguration';

export function removeClassSuffixForOneSearch(modelIdentifiers: string): string {
  return modelIdentifiers.split('_')[0] ?? '';
}

export function removeClassSuffixFromMultipleIdentifier(modelIds: string | undefined): string {
  if (!modelIds) {
    return '';
  }
  const resultArray = modelIds.split(',');
  const processedArray = resultArray.map((modelId) => removeClassSuffixForOneSearch(modelId));
  const concatenatedResult = processedArray.join(',');
  return concatenatedResult;
}

export function isOneSearchGraphQlType(
  parameter: OneSearchVehicleTileDataParams,
): parameter is OneSearchVehicleTileDataParams {
  return (parameter as OneSearchVehicleTileDataParams).profileId !== undefined;
}

export function getRequestGraphQLConfiguration(
  isVan: boolean,
  configuration: SharedRequestConfiguration,
  parameter: OneSearchVehicleTileDataParams,
): OneSearchVehicleTileDataParams {
  if (isVan) {
    const vansConfig = createVanConfiguration(parameter, configuration);
    const parameterBody = parameter.bodyType && parameter.bodyType.length > 0 ? parameter.bodyType[0] : undefined;
    const bodyType = parameterBody ? parameterBody : (vansConfig.bodyType ?? '');
    if ('vehicleCategory' in vansConfig) {
      if (isOneSearchGraphQlType(parameter)) {
        return {
          ...parameter,
          brand: parameter.brand,
          bodyType: [bodyType],
          fuelType: [vansConfig.fuelType],
          modelIdentifier: [vansConfig.modelIdentifier ?? ''],
          vehicleCategory: vansConfig.vehicleCategory ?? vehicleCategoryCommercial,
        };
      } else {
        return parameter;
      }
    }
  }
  return {
    ...parameter,
    brand: parameter.brand,
    vehicleCategory: vehicleCategoryPrivate,
  };
}
